<template>
  <v-switch
    v-bind="filteredProps"
    v-model='internalValue'
    class="w-switch--selection"
    :class="{ 'w-switch--selection--has-label': $props.label }"
    :label='computedLabel'
    :disabled="readonly"
    hide-details
    v-on="$listeners"
  />
</template>

<script>
// components
import { VSwitch } from "vuetify/lib";

// mixins
import requireable from '@/mixins/component/requireable-mixin';
import pendingAble from '@/mixins/component/pending-able-mixin';

// helpers
import { filterProps } from '@/utils/functional-component-utils';

export default {
  mixins: [requireable, pendingAble],
  model: ['value'],
  props: {
    ...VSwitch.options.props,
    nullOnFalse: { type: Boolean, default: false }
  },
  data() {
    return {
      internalValue: this.value,
    };
  },
  computed: {
    filteredProps() {
      return filterProps(this.$props, ['value', 'label']);
    }
  },
  watch: {
    internalValue(newValue) {
      if (!newValue && this.nullOnFalse) {
        return this.$emit('input', null);
      }
      this.$emit('input', newValue);
    },
    value(newValue) {
      if (newValue !== this.internalValue) {
        this.internalValue = newValue;
      }
    }
  }
};
</script>

<style lang="scss">
.w-switch {
  &--selection {
    padding-top: 0;
    margin-top: 0;

    &--has-label {
      .v-input__slot > .v-label {
        @include w-p4;
      }
    }
  }
}
</style>
